/*
 * @Date: 2020-03-20 14:15:59
 * @LastEditors: miaomiaodeng
 * @LastEditTime: 2020-03-20 15:54:24
 * @FilePath: /rongxin.ins.dashboard/src/components/share/locaton-select/service.js
 */
import Vue from 'vue';

// 获取区域列表
function getLocationList(areaCode) {
  return Vue.axios.get('/api/v1.0/area/list?current=' + areaCode );
}

export default {
  getLocationList
};
